import React, { useState } from "react";
import { Chart } from "primereact/chart";
import { Button } from "primereact/button";
import ChartDivider from "../../ChartDivider";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";
import { getDayOfWeekChartOptions } from "../../../../utils/chartOptions/dashboard/frequency";

const DayOfWeek = React.memo(function DayOfWeek(props) {
  const options = getDayOfWeekChartOptions(
    props?.dayOfWeekGraph,
    props?.activeButtonDayOfWeek,
  );
  const handleClick = (label) => props?.setActiveButtonDayOfWeek(label);

  return (
    <div className="mt-4" style={{ maxWidth: "100%" }}>
      <div className="mb-4">
        <h5 className="fw-bold mb-2 text-start">
          <span>Day of Week</span>
          <div
            className="d-flex align-items-center gap-2"
            style={{ float: "right" }}
          >
            {/* <Button
              label="% of Total"
              className={`px-3 py-2 fw-bold fs-6 ${
                props?.activeButtonDayOfWeek === "% OF TOTAL"
                  ? "btn-primary text-white"
                  : "btn-light text-dark"
              }`}
              onClick={() => handleClick("% OF TOTAL")}
              style={{
                borderRadius: "10px",
                border: "none",
                height: "25px",
                backgroundColor:
                  props?.activeButtonDayOfWeek === "% OF TOTAL"
                    ? "#002D42"
                    : "#E0E0E0",
              }}
            /> */}
            {/* <Button
              label="# of Uses"
              className={`px-3 py-2 fw-bold fs-6 ${
                props?.activeButtonDayOfWeek === "# OF USES"
                  ? "btn-primary text-white"
                  : "btn-light text-dark"
              }`}
              onClick={() => handleClick("# OF USES")}
              style={{
                borderRadius: "10px",
                border: "none",
                height: "25px",
                backgroundColor:
                  props?.activeButtonDayOfWeek === "# OF USES"
                    ? "#002D42"
                    : "#E0E0E0",
              }}
            /> */}
          </div>
        </h5>
        {/* <h6 className="fw-bold mb-2 text-start">Base: Uses</h6> */}
        <p
          className="mb-0 text-start fw-bold fs-12 pb-3"
          style={{ color: "#6c757d" }}
        >
          {props?.activeButtonDayOfWeek === "# OF USES"
            ? "Average count of daily product uses by day of week"
            : "% of product uses by day of week"}
        </p>
        <div className="col-12">
          {!props?.dayOfWeekLoader ? (
            <Chart
              type="bar"
              data={props?.dayOfWeekGraph}
              options={options}
              redraw={(props?.isFilterHide || props?.showSidebar).toString()}
            />
          ) : (
            <ChartSkeleton />
          )}
        </div>
        <ChartDivider />
      </div>
    </div>
  );
});

export default DayOfWeek;
